import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"default","breakpoints":{"xxs":426,"xs":500,"sm":768,"md":992,"lg":1367,"xl":1537,"xxl":Infinity}})
